import "./App.css";
import store, { persistor } from "./store";
import { Routes, Route, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Settings from "./pages/Settings";
import Layout from "./components/Layout";
import GenerateParameters from "./pages/GenerateParameters";
import Library from "./pages/Library";
import Community from "./pages/Community";
import Profile from "./pages/Profile";
import SearchResultsPage from "./pages/SearchResultsPage";
import TimerProvider from "./components/TimerProvider";
import TimerWidget from "./components/TimerWidget";
import GenerateDashboard from "./pages/GenerateDashboard";
import GenerateImage from "./pages/GenerateImage";
import Contact from "./pages/Contact";
import SingleRecipe from "./pages/SingleRecipe";
import SinglePost from "./pages/SinglePost";
import FAQ from "./pages/FAQ";
import ToS from "./pages/ToS";
import Privacy from "./pages/Privacy";
import GenerateName from "./pages/GenerateName";

function App() {
    const location = useLocation();
    const hideTimerWidget = ["/login", "/register"].includes(location.pathname);

    return (
        <Provider store={store}>
            <PersistGate persistor={persistor} loading={null}>
                <TimerProvider>
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/settings" element={<Settings />} />
                            <Route path="/generate" element={<GenerateDashboard />} />
                            <Route path="/generate/name" element={<GenerateName />} />
                            <Route path="/generate/parameters" element={<GenerateParameters />} />
                            <Route path="/generate/image" element={<GenerateImage />} />
                            <Route path="/library" element={<Library />} />
                            <Route path="/community" element={<Community />} />
                            <Route path="/profile" element={<Profile />} />
                            <Route path="/profile/:username" element={<Profile />} />
                            <Route path="/search" element={<SearchResultsPage />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/recipe/:objectId" element={<SingleRecipe type="recipeId" />} />
                            <Route path="/recipe/code/:objectId" element={<SingleRecipe type="recipeCode" />} />
                            <Route path="/post/:postId" element={<SinglePost />} />
                            <Route path="/faq" element={<FAQ />} />
                            <Route path="/tos" element={<ToS />} />
                            <Route path="privacy" element={<Privacy />} />
                        </Routes>
                    </Layout>
                    {!hideTimerWidget && <TimerWidget />}
                </TimerProvider>
            </PersistGate>
        </Provider>
    );
}

export default App;
